import LoadingDots from "../components/LoadingDots";
import { s } from "../lib/constants";

export default function AnalyzingScreen({ bothReady }) {
  return (
    <div style={s.step}>
      <p style={s.eyebrow}>{bothReady ? "analysing…" : "waiting for the other person…"}</p>
      <p style={s.display}>{bothReady ? "Reading both sides" : "Your answers are saved"}</p>
      <p style={s.body}>
        {bothReady
          ? "The AI is comparing your answers now."
          : "Once they finish, the analysis will begin automatically."}
      </p>
      <LoadingDots />
    </div>
  );
}
